"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCreateCustomerAcceptedTerm = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _logger = require("@ori/logger");
const useCreateCustomerAcceptedTerm = () => {
  const localLogger = (0, _logger.useLogger)('useCreateCustomerAcceptedTerm');
  const apiClient = (0, _globalApiClientReact.useApiClient)();
  const acceptTerm = async (customerId, termId) => {
    // don't accept T&C during the development
    if (process.env.NODE_ENV !== 'production') {
      return;
    }
    await (0, _globalApiClientReact.createCustomerAcceptedTerm)(apiClient, customerId, {
      termId
    }).catch(error => {
      localLogger.error(new Error(`Failed to accepting Terms and Conditions for customerId: '${customerId}' and termId: '${termId}'`, {
        cause: error
      }));
    });
  };
  return {
    acceptTerm
  };
};
exports.useCreateCustomerAcceptedTerm = useCreateCustomerAcceptedTerm;
